module.exports = __webpack_public_path__ + "statics/img/01.49340fc9.jpg";